import {
  RESET_PREDEFINED_MESSAGES,
  RESET_PREDEFINED_MESSAGE,
  RESET_ERROR,
  GET_PREDEFINED_MESSAGES,
  SET_PREDEFINED_MESSAGES,
  API_ERROR,
  CREATE_PREDEFINED_MESSAGE,
  CREATE_PREDEFINED_MESSAGE_SUCCESS,
  GET_PREDEFINED_MESSAGE,
  SET_PREDEFINED_MESSAGE,
  EDIT_PREDEFINED_MESSAGE,
  EDIT_PREDEFINED_MESSAGE_SUCCESS,
  DELETE_PREDEFINED_MESSAGE,
  DELETE_PREDEFINED_MESSAGE_SUCCESS,
  GET_PREDEFINED_MESSAGES_CONVERSATION,
  GET_PREDEFINED_MESSAGES_CONVERSATION_SUCCESS,
  GET_PREDEFINED_MESSAGES_CONVERSATION_ERROR
} from "./actionTypes";

const initialState = {
  errorPredefinedMessage: false,
  loadingPredefinedMessage: false,
  dataPredefinedMessage: null,
  successPredefinedMessage: false,
  loadingPredefinedMessageGlobal: false,
  global: null,
  skills: {},
};

const PredefinedMessage = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PREDEFINED_MESSAGES:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessage: false,
        loadingPredefinedMessageDelete: false,
        successPredefinedMessage: false,
        dataPredefinedMessage: null,
        dataPredefinedMessageDelete: null,
      };
      break;
    case RESET_PREDEFINED_MESSAGE:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessage: false,
        successPredefinedMessage: false,
        dataPredefinedMessageGetSet: null,
        dataPredefinedMessageEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessage: false,
        loadingPredefinedMessageEditCreate: false,
        loadingPredefinedMessageActivate: false,
        successPredefinedMessage: false,
      };
      break;
    case GET_PREDEFINED_MESSAGES:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessage: true,
        dataPredefinedMessage: null,
      };
      break;
    case SET_PREDEFINED_MESSAGES:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessage: false,
        dataPredefinedMessage: action.payload,
      };
      break;
    case CREATE_PREDEFINED_MESSAGE:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessageEditCreate: true,
        dataPredefinedMessageEditCreate: action.payload,
        successPredefinedMessage: false,
      };
      break;
    case CREATE_PREDEFINED_MESSAGE_SUCCESS:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessageEditCreate: false,
        dataPredefinedMessageEditCreate: action.payload,
        successPredefinedMessage: true,
      };
      break;
    case GET_PREDEFINED_MESSAGE:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessage: true,
        dataPredefinedMessageGetSet: null,
      };
      break;
    case SET_PREDEFINED_MESSAGE:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessage: false,
        dataPredefinedMessageGetSet: action.payload,
      };
      break;
    case EDIT_PREDEFINED_MESSAGE:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessageEditCreate: true,
        dataPredefinedMessageEditCreate: action.payload,
        successPredefinedMessage: false,
      };
      break;
    case EDIT_PREDEFINED_MESSAGE_SUCCESS:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessageEditCreate: false,
        dataPredefinedMessageEditCreate: action.payload,
        successPredefinedMessage: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorPredefinedMessage: action.payload,
        loadingPredefinedMessage: false,
        loadingPredefinedMessageDelete: false,
        successPredefinedMessage: false,
        loadingPredefinedMessageEditCreate: false,
      };
      break;
    case DELETE_PREDEFINED_MESSAGE:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessageDelete: true,
        dataPredefinedMessageDelete: action.payload,
        successPredefinedMessage: false,
      };
      break;
    case DELETE_PREDEFINED_MESSAGE_SUCCESS:
      state = {
        ...state,
        errorPredefinedMessage: false,
        loadingPredefinedMessageDelete: false,
        dataPredefinedMessageDelete: action.payload,
        successPredefinedMessage: true,
      };
      break;
    case GET_PREDEFINED_MESSAGES_CONVERSATION: {
      return {
        ...state,
        loadingPredefinedMessage: action.payload.skillId ? true : state.loadingPredefinedMessage,
        loadingPredefinedMessageGlobal: !action.payload.skillId ? true : state.loadingPredefinedMessageGlobal,
      };
    }
    case GET_PREDEFINED_MESSAGES_CONVERSATION_SUCCESS: {
      return {
        ...state,
        global: action.payload.skillId ? state.global : action.payload.data,
        skills: {
          ...state.skills,
          ...(action.payload.skillId
            ? { [action.payload.skillId]: action.payload.data }
            : {}),
        },
        loadingPredefinedMessage: action.payload.skillId ? false : state.loadingPredefinedMessage,
        loadingPredefinedMessageGlobal: !action.payload.skillId ? false : state.loadingPredefinedMessageGlobal,
      };
    }

    case GET_PREDEFINED_MESSAGES_CONVERSATION_ERROR: {
      return {
        ...state,
        global: action.payload.skillId ? state.global : [],
        skills: {
          ...state.skills,
          ...(action.payload.skillId
            ? { [action.payload.skillId]: []}
            : {}),
        },
        loadingPredefinedMessage: action.payload.skillId ? false : state.loadingPredefinedMessage,
        loadingPredefinedMessageGlobal: !action.payload.skillId ? false : state.loadingPredefinedMessageGlobal,
      };
    }

    default:
      // state = { ...state, errorPredefinedMessage: false, loadingPredefinedMessage: false };
      break;
  }
  return state;
};

export default PredefinedMessage;
